import { isObject } from 'lodash';

/**
 * Validates a token type local variable action block.
 * Passes when a non-empty value is selected, all enum options in the metadata have
 * non-empty value and text fields, and the delay configuration is valid.
 * @param {object|undefined} metadataField - metadata field object from the action block fields array
 * @param {string} selectedValue - currently selected token value string
 * @param {boolean} isDelayValid - whether the action delay configuration is valid
 * @returns {boolean} - true if the token local variable action block is valid
 */
export const isTokenLocalVariableValid = (metadataField, selectedValue, isDelayValid) => {
    const tokenEnumValue = metadataField?.value?.enumValue;
    const isTokenEnumValuesNotEmpty =
        isObject(tokenEnumValue) &&
        Object.values(tokenEnumValue).every((option) => option.value !== '' && option.text !== '');

    return selectedValue !== '' && isTokenEnumValuesNotEmpty && isDelayValid;
};
